import { createSubscriptionHook } from '~/shared/providers/api';

export const usePrinterEventsSubscription = createSubscriptionHook(
  'iot.printerEvents',
  () => ({
    iotPrinterEvents: {
      id: true,
      name: true,
      status: true,
    },
  }),
  {
    select: ({ iotPrinterEvents }) => iotPrinterEvents,
  },
);
